/**
 * Problem paragraph HTML renderer.
 */
import React from "react";

import SafeHtml from "pages/common/SafeHtml";

/**
 * Renders a `<p>` OLX child as sanitized HTML.
 *
 * @param {{ tag: Element }} props
 */
export default function PRender(props) {
  const { tag } = props;

  return <SafeHtml className="mt-3 mb-3" html={tag.innerHTML} course />;
}